import { FormattedMessage } from 'react-intl'

import HeartActiveIcon from 'app/assets/icons/listing/heart-active.svg'
import HeartIcon from 'app/assets/icons/listing/heart.svg'
import Button from 'app/components/base/Button'
import useLikeListing from 'app/hooks/useLikeListing'
import useAuthStore, { getAuthUserId } from 'app/store/auth.store'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

interface AddToWishlistButtonProps {
  listingId: string
  listingUserId?: string
  isLiked?: boolean
}

const AddToWishlistButton = ({
  listingId,
  listingUserId,
  isLiked = false
}: AddToWishlistButtonProps) => {
  const userId = useAuthStore(getAuthUserId)

  const { liked, toggleLike, isLoading } = useLikeListing({
    listingId,
    isLiked
  })

  const isOwner = userId === listingUserId

  return (
    <>
      {!isOwner && (
        <Button
          variant="text"
          size="small"
          startIcon={liked ? <HeartActiveIcon /> : <HeartIcon />}
          {...(IS_NATIVE_APP && {
            icon: liked ? HeartActiveIcon : HeartIcon,
            labelSx: { fontWeight: 500, fontSize: 15 }
          })}
          sx={{
            px: 0,
            ...(IS_NATIVE_APP && {
              width: liked ? 200 : 180,
              mt: 2
            }),
            ...(!IS_NATIVE_APP && {
              width: liked ? 180 : 160,

              '&.MuiLoadingButton-root': {
                fontSize: 15,
                fontWeight: 500,
                lineHeight: '22px'
              }
            })
          }}
          aria-label="Add to Wishlist"
          disabled={isLoading}
          onClick={(e) => {
            if (!IS_NATIVE_APP) e.stopPropagation()

            toggleLike()
          }}
        >
          {liked ? (
            <FormattedMessage defaultMessage="Added to Wishlist" />
          ) : (
            <FormattedMessage defaultMessage="Add to Wishlist" />
          )}
        </Button>
      )}
    </>
  )
}

export default AddToWishlistButton
